import { memo, useState, useCallback } from 'react'
import { Link as RouterLink } from 'react-router-dom'
import { GS } from 'back-end-api'

import LogoFull from 'assets/LogoFull'
import { useTranslation } from 'services/Translation'

import { ROUTES } from 'Constants'
import texts from './Texts'
import InviteModal from './InviteModal'

const TopBar = () => {
  const { t } = useTranslation(texts)
  const [inviteOpen, setInviteOpen] = useState(false)

  const openInvite = useCallback(() => setInviteOpen(true), [])
  const closeInvite = useCallback(() => setInviteOpen(false), [])

  // Wallet participation is the inverse of in-house status: an in-house
  // (employed) doctor does NOT participate in the freelance wallet, so the
  // "Wallet & Analytics" entry is hidden for them (Requirements 5.1, 6.3).
  // Written defensively so it works whether in_house_doctor is true, false, or absent.
  const account = GS.useOwnAccount({ refreshInterval: 0 })
  const showWallet = !account?.data?.in_house_doctor

  return (
    <div className="h-12 w-full flex items-end justify-between">
      <RouterLink to={ROUTES.HOME} className="ml-10">
        <LogoFull />
      </RouterLink>
      <nav className="flex mr-20 space-x-20 font-csc55 text-sm text-grey-200">
        <RouterLink to={ROUTES.HOME} className="hover:text-blue-900 transition">
          {t('home')}
        </RouterLink>
        <RouterLink to={ROUTES.SCHEDULE} className="hover:text-blue-900 transition">
          {t('schedule')}
        </RouterLink>
        {showWallet && (
          <RouterLink to={ROUTES.WALLET} className="hover:text-blue-900 transition">
            {t('wallet')}
          </RouterLink>
        )}
        <button type="button" className="hover:text-blue-900 transition cursor-pointer bg-transparent border-none p-0 font-csc55 text-sm text-grey-200" onClick={openInvite}>{t('invite')}</button>
      </nav>
      {inviteOpen && <InviteModal onClose={closeInvite} />}
    </div>
  )
}

TopBar.whyDidYouRender = true

export default memo(TopBar)
